<template>
    <div v-if="visible" class="toast-container">
      <div class="toast" :class="type">
        <div class="toast-content">
          {{ message }}
        </div>
        <button v-if="showClose" @click="hide" class="toast-close">&times;</button>
      </div>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  
  export default {
    name: 'ToastNotification',
    setup() {
      const visible = ref(false);
      const message = ref('');
      const type = ref('info');
      const timeout = ref(null);
      const showClose = ref(true);
  
      const show = (msg, options = {}) => {
        message.value = msg;
        type.value = options.type || 'info';
        showClose.value = options.showClose !== false;
        visible.value = true;
  
        if (timeout.value) {
          clearTimeout(timeout.value);
        }
  
        if (options.duration !== 0) {
          timeout.value = setTimeout(() => {
            hide();
          }, options.duration || 5000);
        }
      };
  
      const hide = () => {
        visible.value = false;
        if (timeout.value) {
          clearTimeout(timeout.value);
          timeout.value = null;
        }
      };
  
      return {
        visible,
        message,
        type,
        showClose,
        show,
        hide
      };
    }
  };
  </script>
  
  <style scoped>
  .toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 9999;
  }
  
  .toast {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    min-width: 250px;
    max-width: 350px;
  }
  
  .toast-content {
    flex: 1;
  }
  
  .toast-close {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    margin-left: 8px;
    opacity: 0.6;
  }
  
  .toast-close:hover {
    opacity: 1;
  }
  
  .info {
    border-left: 4px solid #60A5FA;
  }
  
  .success {
    border-left: 4px solid #34D399;
  }
  
  .warning {
    border-left: 4px solid #FC8181;
  }
  
  .error {
    border-left: 4px solid #DC2626;
  }
  </style>